<template>
  <div class="px-3">
    <van-row class="video-stat d-flex align-items-center border-bottom-0">
      <van-col @click="firstReply=true"
               class="w-100 mt-2 mb-4 rounded-lg bg-primary text-center text-white color-88 font-10 pl-2 d-flex align-items-center">
        <div class="w-100 py-2 text-center text-white font-14 cursor-pointer">记学习笔记</div>
      </van-col>
    </van-row>
    <div class="hbl-fa">
      <div class="hbl-comm" v-if="firstReply">
        <div class="comment">
          <van-field
            :autosize="{ minRows: minRows, maxRows: maxRows}"
            :placeholder=placeholder
            @focus="showButton(0)"
            maxlength="200"
            rows="3"
            show-word-limit
            type="textarea"
            v-model="textareaMap[0]"
          />

          <div class="hbl-owo">
            <div :class="!pBodyMap[0]?'OwO':'OwO OwO-open'" class="emoj publish">
<!--              <div @click="pBodyStatus(0)" class="OwO-logo">-->
<!--                <img src='/static/img/icon/emoji.png' alt="">-->
<!--              </div>-->
              <div class="OwO-body">
                <ul class="OwO-items OwO-items-show">
                  <li :key="'oitem'+index" @click="choseEmoji(0,oitem.title)" class="OwO-item"
                      v-for="(oitem,index) in OwOlist">
                    <img :src="'/static/img/face/'+oitem.url" alt="">
                  </li>
                </ul>

              </div>
            </div>

            <div class="publish publish-btn">
              <button @click="doSend" class="btn">发送</button>
              <button @click="firstReply=false" class="btn btn-cancel">取消</button>
            </div>
          </div>
        </div>
      </div>

      <van-tabs @click="getCommentList" class="border-bottom" color="#2474FF" v-model="active">
        <van-tab title="热门"></van-tab>
        <van-tab title="最新"></van-tab>

      </van-tabs>
      <div v-if="commentList && commentList.length>0">
        <div class="hbl-child" v-for="(item,index) in commentList">
          <div class="reply">
          </div>
          <div class="content">
            <div class="comment-f">
              <div class="d-flex align-items-center">
                <avatar :avatar="item.user.avatarUrl"></avatar>
                <div class="nickname author">
                  {{item.user.nickname}}
                </div>
                <div class="date ml-1">
                  {{item.createdTime | dateTransForm}}
                </div>
              </div>
            </div>
            <div class="reply-content" v-html="analyzeEmoji(item.content)">{{analyzeEmoji(item.content)}}</div>
            <div class="reply-content reply-fa mb-3">
              <div class="reply-font">
                <div class="d-flex justify-content-between align-items-center">
                  <comment-like-component :item="item"></comment-like-component>
                  <div @click="doReply(item.id)" class="ml-auto d-flex align-items-center">
                    <img class="icon-reply" src="/static/img/icon/reply.png"><span class="icon-reply icon-hf">回复</span>
                  </div>
                </div>

              </div>

              <div class="comment" v-if="replyMap[item.id]">
                <van-field
                  :autosize="{ minRows: minRows, maxRows: maxRows}"
                  :placeholder=placeholder
                  @focus="showButton(item.id)"
                  maxlength="200"
                  rows="3"
                  show-word-limit
                  type="textarea"
                  v-model="textareaMap[item.id]"
                />

                <div class="hbl-owo">
                  <div :class="!pBodyMap[item.id]?'OwO':'OwO OwO-open'"
                       class="emoj publish">
<!--                    <div @click="pBodyStatus(item.id)" class="OwO-logo">-->
<!--                      <img src='/static/img/icon/emoji.png' alt="">-->
<!--                    </div>-->
                    <div class="OwO-body">
                      <ul class="OwO-items OwO-items-show">
                        <li :key="'oitem'+index" @click="choseEmoji(item.id,oitem.title)" class="OwO-item"
                            v-for="(oitem,index) in OwOlist">
                          <img :src="'/static/img/face/'+oitem.url" alt="">
                        </li>
                      </ul>
                    </div>
                  </div>

                  <div class="publish publish-btn">
                    <button @click="doChidSend(item.id,item,item.id)" class="btn">发送</button>
                    <button @click="cancel(item.id)" class="btn btn-cancel">取消</button>
                  </div>
                </div>

              </div>
            </div>
          </div>

          <div class="children" v-for="(ritem,jndex) in item.children">
            <div class="reply">
            </div>
            <div class="content">
              <div class="comment-f">

              </div>

              <div class="comment-f">
                <div class="d-flex align-items-center">
                  <avatar :avatar="ritem.user.avatarUrl"></avatar>
                  <div class="nickname author">
                    {{ritem.user.nickname}}
                  </div>
                  <div class="date ml-1">
                    {{ritem.createdTime | dateTransForm}}
                  </div>


                </div>
              </div>

              <div class="reply-content">
                回复<span class="cc cc-to text-primary">
                  {{ritem.replyCommenterName}}
                </span>:
                <span class="cc word-break ml-1" v-html="analyzeEmoji(ritem.content)">{{analyzeEmoji(ritem.content)}}</span>
              </div>

              <div class="reply-content reply-fa">
                <div class="reply-font">
                  <div class="d-flex justify-content-between align-items-center">
                    <comment-like-component :item="ritem"></comment-like-component>
                    <div @click="doReply(ritem.id)" class="ml-auto d-flex align-items-center">
                      <img class="icon-reply" src="/static/img/icon/reply.png"><span class="icon-reply icon-hf">回复</span>
                    </div>
                  </div>
                </div>

                <div class="comment" v-if="replyMap[ritem.id]">
                  <van-field
                    :autosize="{ minRows: minRows, maxRows: maxRows}"
                    :placeholder=placeholder
                    @focus="showButton(ritem.id)"
                    maxlength="200"
                    rows="3"
                    show-word-limit
                    type="textarea"
                    v-model="textareaMap[ritem.id]"
                  />
                  <div class="hbl-owo">
                    <div :class="!pBodyMap[ritem.id]?'OwO':'OwO OwO-open'"
                         class="emoj publish">
<!--                      <div @click="pBodyStatus(ritem.id)" class="OwO-logo">-->
<!--                        <img src="/static/img/icon/emoji.png" alt="">-->
<!--                      </div>-->
                      <div class="OwO-body">
                        <ul class="OwO-items OwO-items-show">
                          <li :key="'oitem'+index" @click="choseEmoji(ritem.id,oitem.title)" class="OwO-item"
                              v-for="(oitem,index) in OwOlist">
                            <img :src="'/static/img/face/'+oitem.url" alt="">
                          </li>
                        </ul>

                      </div>
                    </div>

                    <div class="publish publish-btn">
                      <button @click="doChidSend(ritem.id,ritem,item.id)" class="btn">发送</button>
                      <button @click="cancel(ritem.id)" class="btn btn-cancel">取消</button>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
    <div class="text-center py-3 mb-4"  v-if="!loading">
      <img width="25%" :src="noMoreImage">
    </div>
  </div>

</template>

<script>
  import Vue from 'vue';
  import {Col, Field, Icon, Row, Tab, Tabs} from 'vant';

  Vue.use(Field);
  Vue.use(Tab);
  Vue.use(Tabs);
  Vue.use(Icon);
  Vue.use(Col);
  Vue.use(Row);
  import commentLikeComponent from './commentLikeComponent';
  import avatar from './Avatar.vue'
  import {mapState} from "vuex";

  export default {

    props: [
      'mainId',
      'type',
    ],
    data() {
      return {
        active: 0,
        firstReply: false,
        loading: false,
        commentList: [],
        commentObj: {},
        replyMap: [],
        buttonMap: [],
        pBodyMap: [],
        textareaMap: [],
        OwOlist: [//表情包和表情路径
          {'title': '微笑', 'url': 'weixiao.gif'},
          {'title': '嘻嘻', 'url': 'xixi.gif'},
          {'title': '哈哈', 'url': 'haha.gif'},
          {'title': '可爱', 'url': 'keai.gif'},
          {'title': '可怜', 'url': 'kelian.gif'},
          {'title': '挖鼻', 'url': 'wabi.gif'},
          {'title': '吃惊', 'url': 'chijing.gif'},
          {'title': '害羞', 'url': 'haixiu.gif'},
          {'title': '挤眼', 'url': 'jiyan.gif'},
          {'title': '闭嘴', 'url': 'bizui.gif'},
          {'title': '鄙视', 'url': 'bishi.gif'},
          {'title': '爱你', 'url': 'aini.gif'},
          {'title': '泪', 'url': 'lei.gif'},
          {'title': '偷笑', 'url': 'touxiao.gif'},
          {'title': '亲亲', 'url': 'qinqin.gif'},
          {'title': '生病', 'url': 'shengbing.gif'},
          {'title': '太开心', 'url': 'taikaixin.gif'},
          {'title': '白眼', 'url': 'baiyan.gif'},
          {'title': '右哼哼', 'url': 'youhengheng.gif'},
          {'title': '左哼哼', 'url': 'zuohengheng.gif'},
          {'title': '嘘', 'url': 'xu.gif'},
          {'title': '衰', 'url': 'shuai.gif'},
          {'title': '吐', 'url': 'tu.gif'},
          {'title': '哈欠', 'url': 'haqian.gif'},
          {'title': '抱抱', 'url': 'baobao.gif'},
          {'title': '怒', 'url': 'nu.gif'},
          {'title': '疑问', 'url': 'yiwen.gif'},
          {'title': '馋嘴', 'url': 'chanzui.gif'},
          {'title': '拜拜', 'url': 'baibai.gif'},
          {'title': '思考', 'url': 'sikao.gif'},
          {'title': '汗', 'url': 'han.gif'},
          {'title': '困', 'url': 'kun.gif'},
          {'title': '睡', 'url': 'shui.gif'},
          {'title': '钱', 'url': 'qian.gif'},
          {'title': '失望', 'url': 'shiwang.gif'},
          {'title': '酷', 'url': 'ku.gif'},
          {'title': '色', 'url': 'se.gif'},
          {'title': '哼', 'url': 'heng.gif'},
          {'title': '鼓掌', 'url': 'guzhang.gif'},
          {'title': '晕', 'url': 'yun.gif'},
          {'title': '悲伤', 'url': 'beishang.gif'},
          {'title': '抓狂', 'url': 'zhuakuang.gif'},
          {'title': '黑线', 'url': 'heixian.gif'},
          {'title': '阴险', 'url': 'yinxian.gif'},
          {'title': '怒骂', 'url': 'numa.gif'},
          {'title': '互粉', 'url': 'hufen.gif'},
          {'title': '书呆子', 'url': 'shudaizi.gif'},
          {'title': '愤怒', 'url': 'fennu.gif'},
          {'title': '感冒', 'url': 'ganmao.gif'},
          {'title': '心', 'url': 'xin.gif'},
          {'title': '伤心', 'url': 'shangxin.gif'},
          {'title': '猪', 'url': 'zhu.gif'},
          {'title': '熊猫', 'url': 'xiongmao.gif'},
          {'title': '兔子', 'url': 'tuzi.gif'},
          {'title': '喔克', 'url': 'ok.gif'},
          {'title': '耶', 'url': 'ye.gif'},
          {'title': '棒棒', 'url': 'good.gif'},
          {'title': '不', 'url': 'no.gif'},
          {'title': '赞', 'url': 'zan.gif'},
          {'title': '来', 'url': 'lai.gif'},
          {'title': '弱', 'url': 'ruo.gif'},
          {'title': '草泥马', 'url': 'caonima.gif'},
          {'title': '神马', 'url': 'shenma.gif'},
          {'title': '囧', 'url': 'jiong.gif'},
          {'title': '浮云', 'url': 'fuyun.gif'},
          {'title': '给力', 'url': 'geili.gif'},
          {'title': '围观', 'url': 'weiguan.gif'},
          {'title': '威武', 'url': 'weiwu.gif'},
          {'title': '话筒', 'url': 'huatong.gif'},
          {'title': '蜡烛', 'url': 'lazhu.gif'},
          {'title': '蛋糕', 'url': 'dangao.gif'},
          {'title': '发红包', 'url': 'fahongbao.gif'}
        ],
        maxRows: 8,
        minRows: 1,
        placeholder: '在此输入笔记内容...',
      }
    },
    computed: {
      ...mapState({
        param: state => state.page,
        noMoreImage: state => state.noMoreImage,
      })
    },

    components: {
      avatar,
      commentLikeComponent
    },

    created() {
      this.param.mainType = this.type;
      this.param.mainId = this.mainId;
    },
    mounted() {
      this.getCommentList();
    },
    methods: {

      //获取笔记列表
      getCommentList() {
        this.loading = true;
        this.param.commentType = this.active + 1;
        this.param.keyword = '';
        this.$store.dispatch('getCommentList', this.param).then((res) => {
          if (res) {
            this.commentList = res.list;
            this.loading = false;
          }
        })
      },
      //添加笔记
      doSend() {
        this.$emit("doSend", this.textareaMap[0]);
        this.commentObj.content = this.textareaMap[0];
        this.commentObj.parentId = '';
        this.commentObj.replyCommenter = '';
        this.commentObj.replyCommenterName = '';
        this.commentObj.rootId = '';
        if(this.commentObj.content) {
          this.addComment(0);
        }else {
          this.$toast('请输入笔记内容');
        }

      },
      //发送回复
      doChidSend(index, item, pid) {
        this.$emit("doChidSend", this.textareaMap[index], item.user.id, pid);
        this.commentObj.content = this.textareaMap[index];
        if (item.parentId) {
          this.commentObj.parentId = item.parentId;
        } else {
          this.commentObj.parentId = item.id;
        }
        if (item.replyCommenter) {
          this.commentObj.replyCommenter = item.replyCommenter;
        } else {
          this.commentObj.replyCommenter = item.user.id;
        }
        if (item.replyCommenterName) {
          this.commentObj.replyCommenterName = item.replyCommenterName;
        } else {
          this.commentObj.replyCommenterName = item.user.nickname;
        }
        this.commentObj.rootId = item.rootId;
        if(this.commentObj.content) {
          this.addComment(index);
        }else {
          this.$toast('请输入笔记内容');
        }
      },
      addComment(index) {
        this.commentObj.mainType = this.type;
        this.commentObj.mainId = this.mainId;
        if(this.commentObj && this.commentObj.content && this.commentObj.content.length<5 || this.commentObj.content.length>200) {
          this.$toast('内容字数请在5-200之间！');
          return false;
        }
        this.$store.dispatch('addComment', {model: this.commentObj}).then((res) => {
          if (res) {
            this.$toast('添加成功！');
            this.$set(this.textareaMap, index, '');
            this.replyMap[index] = false;
            this.getCommentList();
          }
        }).catch(err => {
          if (err && err.response.data.consumerMessage) {
            this.$toast(err.response.data.consumerMessage);
          } else {
            this.$toast('添加失败');
          }
        })
      },
      showButton(index) {
        this.$set(this.buttonMap, index, true)
      },
      cancel(index) {
        this.$set(this.textareaMap, index, '');
        this.$set(this.buttonMap, index, false)
        if (index !== 0) {
          this.$set(this.replyMap, index, false)
        }
      },

      //选择表情包
      choseEmoji: function (index, inner) {
        var con = '';
        if (!this.textareaMap[index]) {
          this.$set(this.textareaMap, index, '')
        }
        con = this.textareaMap[index] += '[' + inner + ']';
        this.$set(this.textareaMap, index, con)

      },
      analyzeEmoji: function (cont) {//编译表情替换成图片展示出来
        var pattern1 = /\[[\u4e00-\u9fa5]+\]/g;
        var pattern2 = /\[[\u4e00-\u9fa5]+\]/;
        var content = cont.match(pattern1);
        var str = cont;
        if (content) {
          for (var i = 0; i < content.length; i++) {
            for (var j = 0; j < this.OwOlist.length; j++) {
              if ("[" + this.OwOlist[j].title + "]" == content[i]) {
                var src = this.OwOlist[j].url;
                break;
              }
            }
            var s = "/static/img/face/" + src
            var imoj = "<img src='" + s + "'/>"
            str = str.replace(pattern2, imoj);
          }
        }
        return str;
      },
      doReply(index) {
        /// 回复框只保持一个显示
        this.$set(this.replyMap, index, true);
        for (let v in this.replyMap) {
          if (v === index) {
            this.replyMap[v] = true;
          } else {
            this.replyMap[v] = false;
            this.textareaMap[v] = '';
          }
        }
      },
      pBodyStatus(index) {
        this.$set(this.pBodyMap, index, !this.pBodyMap[index])
      },

    },
  }
</script>
<style scoped type="text/css">
  .comment {
    display: inline-block;
    vertical-align: top;
    width: 100% !important;
  }
  .comment .van-cell {
    border: 1px solid #ededed;
  }

  .comment-avatar {
    display: inline-block;
    vertical-align: top;
  }

  .publish {
    margin-top: 10px;
    display: flex;
    vertical-align: top;
  }

  .publish-btn {
    margin-left: auto;
  }

  .btn {
    width: 70px; /* 宽度 */
    margin-top: 3px;
    border-width: 0px; /* 边框宽度 */
    border-radius: 3px; /* 边框半径 */
    background: #2474ff; /* 背景颜色 */
    cursor: pointer; /* 鼠标移入按钮范围时出现手势 */
    outline: none; /* 不显示轮廓线 */
    color: white; /* 字体颜色 */
    font-size: 14px; /* 字体大小 */
    text-align: center;
    display: inline-block;
    margin-left: 5px;
    margin-right: 5px;
    padding: 0.25rem 0.75rem;
  }
  .btn-cancel {
    background: grey; /* 背景颜色 */
  }

  .tmsgBox {
    position: relative;
    background: #fff;
    padding: 15px;
    margin-bottom: 20px;
    border-radius: 5px;
  }

  .tmsg-respond h3 {
    font-size: 18px;
    font-weight: bold;
    margin-bottom: 8px;
  }

  .tmsg-respond h3 small {
    font-size: smaller;
    cursor: pointer;
  }

  .tmsg-respond textarea {
    background: #f4f6f7;
    height: 100px;
    margin-bottom: 10px;
  }

  .OwO {
    position: relative;
    z-index: 1;
    width: 100% !important;
  }

  .OwO .OwO-logo {
    position: relative;
    border-radius: 4px;
    color: #444;
    display: inline-block;
    background: #fff;
    border: 1px solid #ddd;
    font-size: 13px;
    padding: 0 6px;
    cursor: pointer;
    height: 30px;
    box-sizing: border-box;
    z-index: 2;
    line-height: 24px;
  }

  .OwO .OwO-logo:hover {
    animation: a 5s infinite ease-in-out;
    -webkit-animation: a 5s infinite ease-in-out;
  }

  .OwO .OwO-body {
    position: absolute;
    background: #fff;
    border: 1px solid #ddd;
    z-index: 1;
    top: 29px;
    border-radius: 0 4px 4px 4px;
    display: none;
  }

  .OwO-open .OwO-body {
    display: block;
  }

  .OwO-open .OwO-logo {
    border-radius: 4px 4px 0 0;
    border-bottom: none;
  }

  .OwO-open .OwO-logo:hover {
    animation: none;
    -webkit-animation: none;
  }

  .OwO .OwO-items {
    max-height: 197px;
    overflow: scroll;
    font-size: 0;
    padding: 10px;
    z-index: 999
  }

  .OwO .OwO-items .OwO-item {
    background: #f7f7f7;
    padding: 5px 10px;
    border-radius: 5px;
    display: inline-block;
    margin: 0 10px 12px 0;
    transition: 0.3s;
    line-height: 19px;
    font-size: 20px;
    cursor: pointer;
  }

  .OwO .OwO-items .OwO-item:hover {
    background: #eee;
    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, .14),
    0 3px 1px -2px rgba(0, 0, 0, .2),
    0 1px 5px 0 rgba(0, 0, 0, .12);
    animation: a 5s infinite ease-in-out;
    -webkit-animation: a 5s infinite ease-in-out;
  }

  .OwO .OwO-body .OwO-bar {
    width: 100%;
    height: 30px;
    border-top: 1px solid #ddd;
    background: #fff;
    border-radius: 0 0 4px 4px;
    color: #444;
  }

  .OwO .OwO-body .OwO-bar .OwO-packages li {
    display: inline-block;
    line-height: 30px;
    font-size: 14px;
    padding: 0 10px;
    cursor: pointer;
    margin-right: 3px;
    text-align: center;
  }

  .OwO .OwO-body .OwO-bar .OwO-packages li:first-of-type {
    border-radius: 0 0 0 3px;
  }

  .line-0 {
    line-height: 0 !important;
  }

  /*用户输入表单*/
  .tmsg-r-info {
    margin: 10px 0;
  }

  .tmsg-r-info input {
    height: 30px;
    border-radius: 4px;
    background: #f4f6f7;
  }

  .tmsg-r-info .info-submit {
    margin: 10px 0;
    text-align: center;
  }

  .tmsg-r-info .info-submit p, .tmsg-commentshow h1 {
    /*background: #97dffd;*/
    color: #fff;
    border-radius: 5px;
    cursor: pointer;
    /*transition: all .3s ease-in-out;*/
    height: 30px;
    line-height: 30px;
    text-align: center;
  }

  /*评论列表*/
  .tmsg-comments .tmsg-comments-tip {
    display: block;
    border-left: 2px solid #363d4c;
    padding: 0 10px;
    margin: 40px 0;
    font-size: 20px;
  }

  .tmsg-commentlist {
    margin-bottom: 20px;
  }

  .tmsg-commentshow > .tmsg-commentlist {
    border-bottom: 1px solid #e5eaed;
  }

  .tmsg-c-item {
    border-top: 1px solid #e5eaed;
  }

  .tmsg-c-item article {
    margin: 20px 0;
  }

  .tmsg-c-item article header {
    margin-bottom: 10px;
  }

  .tmsg-c-item article header img {
    width: 65px;
    height: 65px;
    border-radius: 50%;
    float: left;
    transition: all .4s ease-in-out;
    -webkit-transition: all .4s ease-in-out;
    margin-right: 15px;
    object-fit: cover;
  }

  .tmsg-c-item article header img:hover {
    transform: rotate(360deg);
    -webkit-transform: rotate(360deg);
  }

  .tmsg-c-item article header .i-name {
    font-size: 14px;
    margin: 5px 8px 7px 0;
    color: #444;
    font-weight: bold;
    display: inline-block;
  }

  .tmsg-c-item article header .i-class {
    display: inline-block;
    margin-left: 10px;
    background: #dff0d8;
    color: #3c763d;
    border-radius: 5px;
    padding: 3px 6px;
    font-size: 12px;
    font-weight: 400;
  }

  .tmsg-c-item article header .i-time {
    color: #aaa;
    font-size: 12px;
  }

  .tmsg-c-item article section {
    margin-left: 80px;
  }

  .tmsg-c-item article section p img {
    vertical-align: middle;
  }

  .tmsg-c-item article section .tmsg-replay {
    margin: 10px 0;
    font-size: 12px;
    color: #64609E;
    cursor: pointer;
  }

  .hbl-owo {
    display: flex;
    align-items: center;
  }

  .comm {
    padding: 20px;
  }

  .su {
    margin-top: 2px;
    width: 5px;
    height: 23px;
    background: #3CB371; /*#1E90FF*/
  }

  .com-rep {
    display: inline-block;
    vertical-align: top;
  }

  .com-title {
    font-size: 20px;
    margin-left: 5px;
  }

  .com-span {
    font-size: 16px;
  }

  .hbl-fa {
    text-align: left;
    line-height: 0 !important;
  }

  .hbl-comm {
    padding-top: 16px;
    padding-bottom: 16px;
  }

  .reply {
    /*border-top: solid 1px #D9D9D9;*/
  }

  .content {
    margin-top: 20px;
    margin-bottom: 20px;
  }

  .comment-f {
    display: inline-flex;
    vertical-align: top;
  }

  .nickname {
    font-size: 12px;
    margin-left: 4px;
  }

  .author {
    display: inline-block;
  }

  .icon {
    background: #dff0d8;
    color: #3c763d;
    border-radius: 5px;
    padding: 3px 6px;
    font-size: 12px;
    font-weight: 400;
  }

  .date {
    font-size: 10px;
    color: grey;
  }

  .reply-content {
    word-wrap: break-word;
    /*width: 100%;*/
    font-size: 12px;
    line-height: 20px;
    margin-left: 28px;
  }

  .reply-fa {
    margin-top: 5px;
  }

  .reply-font {
    margin-bottom: 5px;
    color: grey;
    cursor: pointer;
  }

  .children {
    padding-left: 18px;
  }

  /*.cc {*/
  /*  display: block;*/
  /*}*/

  .cc-to a {
    text-decoration: none;
    color: #409eff;
  }

  .hbl-child {
    padding: 0;
  }
</style>
